import getSymbolFromCurrency from 'currency-symbol-map';
import Dinero from 'dinero.js';

export { tripFactsheetUrl } from '@koob/utils';

export const ERRORS = {
  REQUIRED: 'Ce champ est requis',
  TAKEN: 'Cette valeur est déjà prise',
  INVALID: 'Cette valeur n’est pas valide',
  EMAIL: 'Cette adresse mail n’est pas valide',
  EMAIL_NOT_FOUND: 'Cette adresse mail n’est pas enregistrée',
};

export const KoobStateEnum = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  VALIDATED: 'validated',
  REFUSED: 'refused',
  NOT_REQUESTED: 'not_requested',
  CANCELED: 'canceled',
  REPLACED: 'replaced',
};

export const initialLocale = {
  value: 'en',
  label: 'EN',
  alpha2: 'gb',
};

export const formatImageLinkForCss = link => {
  return "'" + encodeURI(link) + "'";
};

export const getRole = role => {
  switch (role) {
    case 'to_admin':
      return 'user:roles.toAdmin';
    default:
      return 'user:roles.toUser';
  }
};

export const decodeId = idKoob => {
  if (!idKoob) return null;
  try {
    const result = parseInt(idKoob);
    if (!isNaN(result)) {
      return result;
    }
  } catch (e) {
    return null;
  }
  const decoded = atob(idKoob.replace('\n', ''));
  return parseInt(decoded.substring(decoded.lastIndexOf('/') + 1));
};

export const formatCurrencyLabel = currency =>
  `${currency.toUpperCase()}  ${getSymbolFromCurrency(currency)}`;

// `noSymbol` keeps the number alone (e.g. "2 053,82"), for amounts listed
// next to a total that already shows the currency.
export const formatCurrency = ({
  amount,
  currency,
  noDecimals = false,
  noSymbol = false,
}) => {
  if (!amount && amount !== 0) {
    return '';
  }

  const symbol = noSymbol ? '' : '$';
  try {
    return Dinero({ amount: Math.round(amount * 100), currency })
      .setLocale('fr')
      .toFormat(`${symbol}0,0${noDecimals ? '' : '.00'}`)
      .toUpperCase();
  } catch (err) {
    // An unknown or missing currency must still print a readable amount:
    // the raw float would leak its binary rounding (609.6800000000001).
    const numericAmount = Number(amount);

    return Number.isFinite(numericAmount)
      ? numericAmount.toFixed(noDecimals ? 0 : 2)
      : amount;
  }
};

export const phoneRegex = /^[+]?[0-9]{10,15}$/;

export const viewKind = {
  LIST: 'list',
  MAP: 'map',
};

export const getMostRecent = array => {
  if (!array || array.length === 0) {
    return null;
  }

  return array.reduce((mostRecent, current) => {
    const currentDate = new Date(current.createdAt);
    const mostRecentDate = new Date(mostRecent.createdAt);

    return currentDate > mostRecentDate ? current : mostRecent;
  });
};

export const readFile = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const listSupports = [
  {
    name: 'Website',
  },
  {
    name: 'DMC Recommandation',
  },
  {
    name: 'Social media',
  },
  {
    name: 'Event',
  },
  {
    name: 'Advertisement',
  },
  {
    name: 'Mail',
  },
  {
    name: 'Personal',
  },
  {
    name: 'Others',
  },
];
